"use strict";
exports.__esModule = true;
exports.URL = exports.RAZORPAYKEY = exports.APIPATHENV = void 0;
exports.APIPATHENV = "https://eposapi.ngxconnect.in/api/v1/";
exports.RAZORPAYKEY = "rzp_live_FWFbpTNvqGumEJ";
exports.URL = "https://www.ngxtechnologies.com";
